{
  "title": "FBO-Name bearbeiten",
  "nameLabel": "Name",
  "cancelButton": "Abbrechen",
  "saveButton": "Speichern"
}
